export default "__VITE_ASSET__6cd7a14a__"